/**
 * Lightbox zoom - hover zoom by default, click to toggle (disable/enable) hover zoom (desktop only)
 */
(function () {
  const ZOOM_RATIO = 2;
  const EDGE_GAP = 80;
  var zoomDisabledFor = new WeakSet();

  function createOverlay(image, modal) {
    const overlay = document.createElement('div');
    overlay.setAttribute('class', 'image-magnify-full-size lightbox-zoom-overlay');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.backgroundImage = "url('" + image.src + "')";
    overlay.style.backgroundRepeat = 'no-repeat';
    overlay.style.backgroundColor = 'var(--gradient-background, #fff)';
    overlay.style.position = 'fixed';
    overlay.style.top = EDGE_GAP + 'px';
    overlay.style.left = EDGE_GAP + 'px';
    overlay.style.width = 'calc(100vw - ' + (EDGE_GAP * 2) + 'px)';
    overlay.style.height = 'calc(100vh - ' + (EDGE_GAP * 2) + 'px)';
    overlay.style.zIndex = '1000';
    overlay.style.pointerEvents = 'auto';
    return overlay;
  }

  function moveWithHover(image, event, zoomRatio, overlay) {
    const rect = image.getBoundingClientRect();
    const xPosition = event.clientX - rect.left;
    const yPosition = event.clientY - rect.top;
    const zoomedW = image.clientWidth * zoomRatio;
    const zoomedH = image.clientHeight * zoomRatio;
    const bgX = (event.clientX - EDGE_GAP) - xPosition * zoomRatio;
    const bgY = (event.clientY - EDGE_GAP) - yPosition * zoomRatio;
    overlay.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
    overlay.style.backgroundSize = zoomedW + 'px ' + zoomedH + 'px';
  }

  function removeAllOverlays() {
    document.querySelectorAll('.lightbox-zoom-overlay').forEach(function (el) {
      el.remove();
    });
  }

  function initLightboxZoom() {
    const modal = document.querySelector('product-modal.product-media-modal');
    if (!modal) return;

    const mediaQuery = window.matchMedia('(min-width: 750px)');
    if (!mediaQuery.matches) return;

    const images = modal.querySelectorAll('.product-media-modal__item .lightbox-zoom-image');
    images.forEach(function (image) {
      if (image.dataset.lightboxZoomInit) return;
      image.dataset.lightboxZoomInit = 'true';

      image.addEventListener('mouseenter', function (e) {
        if (zoomDisabledFor.has(image)) return;
        removeAllOverlays();
        const overlay = createOverlay(image, modal);
        document.body.appendChild(overlay);

        overlay.addEventListener('mousemove', function (ev) {
          moveWithHover(image, ev, ZOOM_RATIO, overlay);
        });
        overlay.addEventListener('mouseleave', function () {
          overlay.remove();
        });
        overlay.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          zoomDisabledFor.add(image);
          overlay.remove();
        });
        moveWithHover(image, e, ZOOM_RATIO, overlay);
      });

      image.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (zoomDisabledFor.has(image)) {
          zoomDisabledFor.delete(image);
          removeAllOverlays();
          var overlay = createOverlay(image, modal);
          document.body.appendChild(overlay);
          overlay.addEventListener('mousemove', function (ev) {
            moveWithHover(image, ev, ZOOM_RATIO, overlay);
          });
          overlay.addEventListener('mouseleave', function () {
            overlay.remove();
          });
          overlay.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            zoomDisabledFor.add(image);
            overlay.remove();
          });
          moveWithHover(image, e, ZOOM_RATIO, overlay);
        } else {
          zoomDisabledFor.add(image);
          removeAllOverlays();
        }
      });
    });
  }

  function onModalOpen() {
    initLightboxZoom();
  }

  function setupLightboxZoom() {
    document.addEventListener('DOMContentLoaded', function () {
      var modal = document.querySelector('product-modal.product-media-modal');
      if (!modal) return;

      function onOpen() {
        onModalOpen();
      }

      function onClose() {
        removeAllOverlays();
        zoomDisabledFor = new WeakSet();
      }

      function onMediaChange() {
        removeAllOverlays();
        zoomDisabledFor = new WeakSet();
        onModalOpen();
      }

      modal.addEventListener('productModalShown', onOpen);
      modal.addEventListener('lightboxMediaChange', onMediaChange);

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'open') {
            if (modal.hasAttribute('open')) {
              onOpen();
            } else {
              onClose();
            }
          }
        });
      });
      observer.observe(modal, { attributes: true });
    });
  }

  setupLightboxZoom();
})();
